import { Icon, IconProps } from '@chakra-ui/react'

export function CheckmarkIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 26 26" fill="none" {...props}>
      <path
        d="M13 23.8333C18.9831 23.8333 23.8334 18.983 23.8334 13C23.8334 7.01687 18.9831 2.16663 13 2.16663C7.01693 2.16663 2.16669 7.01687 2.16669 13C2.16669 18.983 7.01693 23.8333 13 23.8333Z"
        stroke="currentColor"
        strokeWidth="1.56184"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4913 18.3757C10.8886 17.9855 10.7164 17.1806 11.1066 16.578L17.0492 7.67148C17.4395 7.06881 18.2444 6.89658 18.847 7.2868C19.4497 7.67702 19.6219 8.48191 19.2317 9.08458L13.289 17.9911C12.8988 18.5937 12.0939 18.766 11.4913 18.3757Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70975 13.937C9.21223 13.4241 10.0353 13.4157 10.5481 13.9182L12.9832 16.2876C13.4961 16.7901 13.5045 17.6132 13.002 18.126C12.4995 18.6388 11.6764 18.6472 11.1636 18.1448L8.72852 15.7754C8.21568 15.2729 8.20728 14.4498 8.70975 13.937Z"
        fill="currentColor"
      />
    </Icon>
  )
}
